export default `Province,Population
Eastern Cape,6562053
Free State,2745590
Gauteng,12272263
KwaZulu-Natal,10267300
Limpopo,5404868
Mpumalanga,4039939
North West,3509953
Northern Cape,1145861
Western Cape,5822734
Republic of South Africa,51770560`